/**
 * Task 3 presentation pacing only.
 * Instruction audio (intro) must finish, then this pause, then topic readout.
 * Does not change startup delay, Deepgram, Finish grace, or topic fetch.
 */

export const TASK3_INSTRUCTION_TO_TOPIC_PAUSE_MS = 1000;

export function claimTask3TopicReadout(claimedRef: { current: boolean }): boolean {
  if (claimedRef.current) return false;
  claimedRef.current = true;
  return true;
}

export function shouldReleaseTask3TopicReadout(input: {
  instructionFinished: boolean;
  pauseElapsed: boolean;
  cancelled: boolean;
  alreadyClaimed: boolean;
  hasTopicPayload: boolean;
}): boolean {
  return (
    input.instructionFinished &&
    input.pauseElapsed &&
    !input.cancelled &&
    !input.alreadyClaimed &&
    input.hasTopicPayload
  );
}

export function scheduleTask3InstructionToTopicPause(input: {
  isCancelled: () => boolean;
  onElapsed: () => void;
  delayMs?: number;
}): { cancel: () => void } {
  const delayMs = input.delayMs ?? TASK3_INSTRUCTION_TO_TOPIC_PAUSE_MS;
  const timer = setTimeout(() => {
    if (input.isCancelled()) return;
    input.onElapsed();
  }, delayMs);
  return {
    cancel: () => clearTimeout(timer),
  };
}
